import React, { useMemo } from 'react';
import { Client, Flight, Hotel, ItineraryItem, TripInfo } from '../../types/Quotation';
import PDFHeader from './PDFHeader';
import PDFPage1 from './PDFPage1';
import PDFPage4 from './PDFPage4';
import { getPdfRenderTimestamp } from './pdfRenderTime';
import FlightCard from './FlightCard';
import HotelCard from './HotelCard';

type StandaloneQuotationPDFProps = {
  kind: 'flight' | 'hotel';
  client: Client;
  tripInfo: TripInfo;
  flights?: Flight[];
  hotel?: Hotel | null;
  checkIn?: string;
  checkOut?: string;
  selectedRoomCount?: number;
};

const StandaloneQuotationPDF: React.FC<StandaloneQuotationPDFProps> = ({
  kind, client, tripInfo, flights = [], hotel, checkIn, checkOut, selectedRoomCount,
}) => {
  const renderedAt = useMemo(() => getPdfRenderTimestamp(), []);
  const emptyItinerary: ItineraryItem[] = [];

  return (
    <div className="preview-pdf">
      <PDFPage1 client={client} tripInfo={tripInfo} itinerary={emptyItinerary} highlights="" renderedAt={renderedAt} />
      <div className="pdf-page">
        <PDFHeader renderedAt={renderedAt} />
        <section className="pdf-section">
          <h2>{kind === 'flight' ? '✈️ Flight Details' : '🏨 Hotel Details'}</h2>
          {kind === 'flight' ? flights.map((flight, index) => (
            <FlightCard key={`${flight.flightNumber}-${index}`} flight={{ ...flight, day: index + 1 }} />
          )) : hotel && (
            <HotelCard
              hotel={{ ...hotel, day: 1, checkInDate: checkIn || hotel.checkInDate, checkOutDate: checkOut || hotel.checkOutDate }}
              variant="inclusion"
              selectedRoomCount={selectedRoomCount}
              travelStartDate={tripInfo.startDate}
            />
          )}
        </section>
      </div>
      <PDFPage4 renderedAt={renderedAt} />
    </div>
  );
};

export default StandaloneQuotationPDF;
